module.exports = __webpack_public_path__ + "fonts/gielda-papierow-wartosciowych-w-warszawie-group-gpw-vector-logo_1.svg";